import { render, staticRenderFns } from "./setInfos.vue?vue&type=template&id=2b783e25&scoped=true"
import script from "./setInfos.vue?vue&type=script&lang=js"
export * from "./setInfos.vue?vue&type=script&lang=js"
import style0 from "./setInfos.vue?vue&type=style&index=0&id=2b783e25&prod&lang=less&scoped=true"
import style1 from "./setInfos.vue?vue&type=style&index=1&id=2b783e25&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b783e25",
  null
  
)

export default component.exports